import type { SyncHasMany } from '@ember-data/model';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import type Employee from 'garaje/models/employee';
import type Flow from 'garaje/models/flow';
import type Location from 'garaje/models/location';

export default class AbstractGroupInvite extends Model {
  @attr('string') declare groupName: string;
  @attr('string', { defaultValue: '' }) declare csv: string;
  @attr('boolean', { defaultValue: true }) declare includeGroupNameInEmail: boolean;
  @attr('string') declare privateNotes: string;
  @attr('boolean', { defaultValue: true }) declare notifyVisitor: boolean;

  @attr() declare importResults: {
    'success-rows': unknown[];
    'error-rows': Array<{ [key: string]: string }>;
  } | null;

  /**
   * progress of group invite, can be in-progress if it is a group invite that originates from a recurring group invite
   */
  @attr('string') declare uploadStatus?: 'in-progress' | 'complete';

  @belongsTo('location', { async: false, inverse: null }) declare location: Location;
  @belongsTo('flow', { async: false, inverse: null }) declare flow: Flow;
  @belongsTo('employee', { async: false, inverse: null }) declare employee: Employee | null;

  @hasMany('employee', { async: false, inverse: null }) declare additionalHosts: SyncHasMany<Employee>;
  // future feature, declared for compatibility with multiple host input field
  @hasMany('location', { async: false, inverse: null }) declare secondaryLocations: SyncHasMany<Location>;

  get hostName(): string {
    return this.employee?.name ?? '';
  }

  get inProgress(): boolean {
    return this.uploadStatus === 'in-progress';
  }
}
